import Reveal from "../components/Reveal";
import { useLang } from "../i18n/LanguageContext";
import Seo from "../components/Seo";

export default function Privacy() {
  const { t } = useLang();

  return (
    <>
      <Seo title={t.meta.privacy.title} description={t.meta.privacy.description} />

      <section className="bg-paper-warm">
        <div className="mx-auto max-w-3xl px-5 pb-24 pt-14 sm:px-8 md:pt-20">
          <Reveal>
            <span data-testid="privacy-draft-badge" className="inline-flex items-center gap-2 rounded-full border border-gold/50 bg-gold/10 px-4 py-1.5 font-heading text-[11px] font-bold uppercase tracking-[0.18em] text-navy-900">
              {t.privacy.draftBadge}
            </span>
            <h1 className="mt-6 font-display text-4xl leading-[1.08] text-navy-900 sm:text-5xl" data-testid="privacy-title">
              {t.privacy.title}
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-navy-900/75">{t.privacy.intro}</p>
          </Reveal>

          <div className="mt-12 space-y-10 border-t border-navy-900/10 pt-10" data-testid="privacy-sections">
            {t.privacy.sections.map((s) => (
              <Reveal key={s.h}>
                <article>
                  <h2 className="font-heading text-xl font-semibold text-navy-900">{s.h}</h2>
                  {s.ps &&
                    s.ps.map((p, i) => (
                      <p key={i} className="mt-3 leading-relaxed text-navy-900/75">
                        {p}
                      </p>
                    ))}
                  {s.list && (
                    <ul className="mt-4 space-y-2.5">
                      {s.list.map((li) => (
                        <li key={li} className="flex gap-3 text-[15px] leading-relaxed text-navy-900/80">
                          <span className="mt-2 h-1.5 w-1.5 shrink-0 rotate-45 bg-gold" aria-hidden="true" />
                          {li}
                        </li>
                      ))}
                    </ul>
                  )}
                  {s.ps2 &&
                    s.ps2.map((p, i) => (
                      <p key={i} className="mt-3 leading-relaxed text-navy-900/75">
                        {p}
                      </p>
                    ))}
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
